import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { AdminAuthComponent } from '../../auth/admin-auth-component/admin-auth-component';
import { OpenSquashService } from '../shared/services/open-squash-service';
import { Tournament } from '../shared/tournament';
import { TournamentCategory } from '../shared/tournament-category';
import { CommonModule } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-v-valida-departamental-component',
  imports: [RouterModule, RouterOutlet, CommonModule],
  templateUrl: './v-valida-departamental-component.html',
  styleUrl: './v-valida-departamental-component.scss'
})
export class VValidaDepartamentalComponent {

private openSquashService = inject(OpenSquashService);
  private dialog = inject(MatDialog);

  tournament!: Tournament;
  categories: TournamentCategory[] = [];
  esAdmin$!: Observable<boolean>;
  tournamentSubscription!: Subscription;

  ngOnInit(): void {
    this.esAdmin$ = this.openSquashService.esAdmin$;
    this.openSquashService.setTournament('v-valida-departamental');
    this.tournamentSubscription = this.openSquashService.tournament$.subscribe(tournament => {
      this.tournament = tournament;
      this.categories = tournament.categories.sort((a, b) => a.categoryOrder - b.categoryOrder);
    });
  }

  authAdmin() {
    this.dialog.open(AdminAuthComponent).afterClosed().subscribe(result => {
      if (result) {
        this.openSquashService.setAsAdmin(true);
      }
    });
  }

  logout() {
    this.openSquashService.setAsAdmin(false);
  }

  ngOnDestroy(): void {
    this.tournamentSubscription.unsubscribe();
  }

}
